import { Instance, types } from 'mobx-state-tree';

export type TeamModel = Instance<typeof Team>;

export const Team = types.model('Team', {
	id: types.union(types.string, types.number),
	name: types.string,
	merchant_id: types.number
});
